// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM
import Vue from 'vue';
import Axios from 'axios';
import { http } from '@/shared/https';
export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 4,
        parentComponent: true,
        hideButtons: ['Edit'],
        redirect: {
            menuId: 30,
            action: '/Admin/System/User/UserForm'
        },
        card: {
            type: 'Grid',
            multiColumn: 2
        },
        actions: {
            listAction: "/api/User/List/",
            deleteAction: "/api/User/",
            updateAction: "/api/User",
            createAction: "/api/User"
        },
        fields: {
            UserId: {
                primaryKey: true
            },
            UserName: {
                required: true,
                type: "TextInput",
                sortable: true,
                title: "User Name",
                redirect: {
                    menuId: 30,
                    action: '/Admin/System/User/UserForm'
                }
            },
            LoginName: {
                required: true,
                type: "TextInput",
                sortable: true,
                title: "Email"
            },
            UserTypeId: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                sortable: true,
                title: "User Type"
            },
            RoleId: {
                type: "Hidden"
                // required: true,
                // type: "ComboBox",
                // autocomplete: true,
                // sortable: true,
                // title: "Default Role"
            },
            BusinessUnitId: {
                required: true,
                weightage: 1,
                type: "ComboBox",
                autocomplete: true,
                sortable: true,
                title: "Default Program"
            },
            EffectiveFrom: {
                required: true,
                type: "Date",
                displayCurrentDate: true,
                sortable: true,
                title: "Effective From"
            },
            EffectiveTo: {
                type: "Date",
                sortable: true,
                title: "Effective To"
            },
            // UserEmail: {
            //     required: true,
            //     list: false,
            //     type: "TextInput",
            //     title: "User Email"
            // },
            UserImage: {
                type: "Hidden"
            },
            IsLocked: {
                // type: "Hidden",
                type: "SwitchInput",
                title: "Lock",
                event: true,
                tooltip: "Lock/Unlock user account"
            },
            RequiredNotification: {
                type: "SwitchInput",
                title: "Notification Status",
                event: true,
                tooltip: "Enable/disable notifcation"
            },
            Password: {
                required: true,
                list: false,
                type: "TextInput",
                password: true,
                title: "Password"
            },
            ConfirmPassword: {
                required: true,
                list: false,
                type: "TextInput",
                password: true,
                title: "Confirm Password"
            },
            Active: {
                required: true,
                list: false,
                autocomplete: true,
                type: "ComboBox",
                title: "Active"
            },
            Reset: {
                prepend: true,
                type: "button",
                icon: "mdi-textbox-password",
                size: "18",
                color: "#557fb5",
                method: "getPasswordReset",
                tooltip: "Reset password"
            },
            SendMail: {
                prepend: true,
                type: "button",
                icon: "mdi-email",
                size: "16",
                color: "#557fb5",
                method: "sendAccountDetails",
                tooltip: "Send user registred email"
            },
            AuthenticationSettingsId: {
                type: "Hidden"
            },
            DocumentStoreId: {
                type: "Hidden"
            },
            MailSent: {
                type: "Hidden"
            },
            CreatedById: {
                type: "Hidden"
            },
            CreatedDate: {
                type: "Hidden"
            },
            UpdatedById: {
                type: "Hidden"
            },
            UpdatedDate: {
                type: "Hidden"
            },
            SysSchemaId: {
                type: "Hidden"
            },
            SysJSON: {
                type: "Hidden"
            },
            CusSchemaId: {
                type: "Hidden"
            },
            CusJSON: {
                type: "Hidden"
            },
            OriginBusinessUnitId: {
                type: "Hidden"
            },
            MaximumLoginAttempts: {
                type: "Hidden"
            },
            LastLoginDate: {
                type: "Hidden"
            },
            LastLogoutDate: {
                type: "Hidden"
            },
            LastLoginIp: {
                type: "Hidden"
            },
            QuestionId: {
                type: "Hidden"
            },
            Answer: {
                type: "Hidden"
            },
            PwdUpdatedDate: {
                type: "Hidden"
            },
            DashboardLayout: {
                type: "Hidden"
            },
            FirstLogin: {
                type: "Hidden"
            },
            MISDashlets: {
                type: "Hidden"
            },
            FavouriteMenu: {
                type: "Hidden"
            },
            FrequentMenu: {
                type: "Hidden"
            },
            LockedListValue: {
                type: "Hidden"
            },
            ReviseButton: {
                type: "Hidden"
            },
            UnlockButton: {
                type: "Hidden"
            }
        },
        userNotify: {
            enabled: false,
            timeout: 0,
            color: 'success',
            text: null,
            mode: '',
            y: 'top',
            x: null,
            value: null
        },
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
        },

        //#. fn_formCancel function
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) {
        },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {
        },

        //#. fn_selectionChanged function
        selectionChanged(state, context) {
        },

        iconInserted(state, context) {
            if (context.payload.field.value == 'SendMail' && context.payload.item.MailSent == 0) {
                context.payload.field.SendMail = true;
            } else {
                context.payload.field.SendMail = false;
            }
        },

        //#. fn_getPasswordReset function
        getPasswordReset(state, context) {
            let userId = state.data[state.formData.indexOf(context.payload.item)].UserId;
            let dashboard = state.dashboard;

            return http.get('/api/User/ResetPassword/' + userId).then(record => {
                if (record.data.Result == 'OK') {
                    dashboard.color = "success";
                    dashboard.text = record.data.Message;
                    dashboard.snackbar = true;
                }
            });
        },

        sendAccountDetails(state, context) {
            let userId = state.data[state.formData.indexOf(context.payload.item)].UserId;
            let dashboard = state.dashboard;
            return http.get('/api/User/SendMail/' + userId).then(record => {
                if (record.data.Result == 'OK') {
                    dashboard.color = "success";
                    dashboard.text = record.data.Message;
                    dashboard.snackbar = true;

                    dashboard.renderComponent = false;
                    Vue.nextTick(() => {
                        //#.Add the component back in
                        context.switches = true;
                        dashboard.renderComponent = true;
                    });
                } else {
                    dashboard.color = "error";
                    dashboard.text = record.data.Message;
                    dashboard.snackbar = true;
                }
            });
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },

        //#. selectionChanged event will be fired	
        selectionChanged: ({ commit, rootState }, payload) => {
            commit('selectionChanged', { rootState, payload });
        },

        iconInserted: ({ commit, rootState }, payload) => {
            commit('iconInserted', { rootState, payload });
        },

        //#. getPasswordReset event will be fired
        getPasswordReset: ({ commit, rootState }, payload) => {
            rootState.userIndex.userNotify.value = payload.item.UserId;
            rootState.userIndex.userNotify.enabled = true;
            rootState.userIndex.userNotify.color = 'confirm';
            rootState.userIndex.userNotify.text = `Are you sure you want to reset this user's password? Notification message will send to the registered email.`;
        },

        getPasswordUnlock: ({ commit, rootState }, payload) => {
            commit('getPasswordUnlock', { rootState, payload });
        },

        sendAccountDetails: ({ commit, rootState }, payload) => {
            commit('sendAccountDetails', { rootState, payload });
        }
    }
}